export const buttonStyle = {
  baseStyle: { fontWeight: "100" },
  size: {},
  variants: {
    primary: {
      bg: "primary",
      color: "white",

      _hover: {
        bg: "primary2",
        color: "white",
        border: "1px solid white",
      },
    },
    primaryAdmin: {
      bg: "primary",
      color: "white",
      borderRadius: "20px",
      _hover: {
        bg: "primary2",
        color: "white",
      },
    },
    primaryAdmin2: {
      color: "black",
      borderRadius: "20px",
      _hover: {
        bg: "primary",
        color: "white",
      },
    },
    secondary: {
      bg: "transparent",
      color: "white",
      border: "1px solid white",

      _hover: {
        bg: "primary",
        color: "white",
        border: "None",
      },
    },
    transButton: {
      bg: "transparent",
      color: "primary",

      _hover: {
        bg: "primary",
        color: "white",
        border: "1px solid transparent",
      },
    },

    transButtonBorder: {
      bg: "transparent",
      color: "primary",
      border: "1px solid #4B978B",
      _hover: {
        bg: "primary",
        color: "white",
      },
    },
    bigButton: {
      bg: "transparent",
      color: "white",

      _hover: {
        bg: "white",
        color: "primary",
      },
    },
    transButton2: {
      bg: "transparent",
      color: "white",

      _hover: {
        bg: "transparent",
        color: "#E2E8F0",
      },
    },
    transButton3: {
      bg: "transparent",
      color: "primary",

      _hover: {
        bg: "transparent",
        color: "black",
      },
    },
    emptysButton: {
      bg: "transparent",
      color: "black",
      border: "0.8px solid black",

      _hover: {
        fontWeight: "700",
        border: "2px solid black",
      },
    },
    emptysButtonWhite: {
      bg: "transparent",
      color: "white",
      border: "0.8px solid white",

      _hover: {
        fontWeight: "700",
        border: "2px solid white",
      },
    },
  },
  defaultProps: {},
};
